<template>
  <div class="el_1_ee9a7f0429ad28da59dd0c16c8b09064 inline-flex justify-center items-center w-4 h-4 bg-primary-400  text-sm rounded-full" />
</template>

